import { render, staticRenderFns } from "./AppCommunicationsView.vue?vue&type=template&id=566a438e"
import script from "./AppCommunicationsView.vue?vue&type=script&lang=ts"
export * from "./AppCommunicationsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports